/**
 * GraphQL queries for Hot Wheels & Wishlist.
 *
 * Verified against the live gateway (introspected 2026-08-03):
 *   - Query.getHotWheels(input, where, order, paging)
 *   - order = [DynamicSortInput!]   (NOT [HotWheelSortInput!] — that
 *     type doesn't exist; this is why the gateway errored previously)
 *   - DynamicSortInput = { field: String!, direction: SortDirection }
 *   - PaginationInput = { pageNo: Int, pageSize: Int }
 *
 * The Wishlist query/mutations follow the same convention.
 */

export const GET_HOT_WHEELS_QUERY = `
  query HotWheels($where: HotWheelFilterInput, $order: [DynamicSortInput!], $paging: PaginationInput) {
    getHotWheels(where: $where, order: $order, paging: $paging) {
      items {
        ItemId
        Brand
        Series
        ModelNumber
        ReleaseYear
        Color
        Scale
        Condition
        PurchasePrice
        EstimatedValue
        PurchaseDate
        StorageLocation
        Description
        Favorite
        TreasureHunt
        SuperTreasureHunt
        LimitedEdition
        PublicVisibility
        MainImage
        AdditionalImages
        CreatedDate
        LastUpdatedDate
        CreatedBy
      }
      totalCount
      totalPages
      pageNo
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const GET_HOT_WHEEL_QUERY = `
  query HotWheel($where: HotWheelFilterInput) {
    getHotWheels(where: $where, paging: { pageNo: 0, pageSize: 1 }) {
      items {
        ItemId
        Brand
        Series
        ModelNumber
        ReleaseYear
        Color
        Scale
        Condition
        PurchasePrice
        EstimatedValue
        PurchaseDate
        StorageLocation
        Description
        Favorite
        TreasureHunt
        SuperTreasureHunt
        LimitedEdition
        PublicVisibility
        MainImage
        AdditionalImages
        CreatedDate
        LastUpdatedDate
      }
      totalCount
    }
  }
`;

export const GET_WISHLIST_QUERY = `
  query Wishlist($paging: PaginationInput) {
    getWishlists(paging: $paging) {
      items {
        ItemId
        CarName
        Brand
        Series
        Priority
        Notes
        Acquired
        CreatedDate
        LastUpdatedDate
      }
      totalCount
      totalPages
      pageNo
      pageSize
      hasNextPage
      hasPreviousPage
    }
  }
`;